import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-labelledby"];
const _hoisted_2 = { class: "form-question__number" };
const _hoisted_3 = ["id"];
const _hoisted_4 = { class: "form-question__answers" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        role: "region",
        "aria-labelledby": _ctx.questionAnswersLabelId
    }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.question.number), 1 /* TEXT */),
        _createElementVNode("h3", {
            id: _ctx.questionAnswersLabelId,
            class: "form-question__title"
        }, _toDisplayString(_ctx.question.title), 9 /* TEXT, PROPS */, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
            (_ctx.componentName)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), { key: 0 }))
                : _createCommentVNode("v-if", true)
        ])
    ], 8 /* PROPS */, _hoisted_1));
}
